import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Correct({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="0 0 39 41"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <path
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.377 21.31l4.928 5.175M27.916 13.54L15.95 26.106M.7 20.155c-.09 10.848 8.198 19.705 18.496 19.8 10.297.096 18.732-8.607 18.823-19.454C38.11 9.653 29.822.796 19.524.701 9.227.605.792 9.308.701 20.155z"
      />
    </svg>
  )
}

Correct.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
